import type { RouteRecordRaw } from 'vue-router'

const pcRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/party/index',
  },
  {
    path: '/party',
    name: 'index',
    component: () => import('@/views/party/index.vue'),
    children: [
      { path: 'index/:anchors*', name: 'index', component: () => import('@/views/party/index/index.vue') },
      { path: 'apply', name: 'apply', component: () => import('@/views/party/apply/apply.vue') },
      { path: 'help/:collection_id?/:doc_id?', name: 'm-help', component: () => import('@/views/party/help/index.vue') },
      { path: 'news/detail/:doc_id?', name: 'news-detail', component: () => import('@/views/party/news/detail.vue') },
    ],
  },
]

const h5Routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/party/apply',
  },
  {
    path: '/party',
    name: 'm-party',
    component: () => import('@/views/h5/index.vue'),
    children: [
      {
        path: 'apply',
        name: 'm-apply',
        component: () => import('@/views/h5/pages/apply.vue'),
      },
      { path: 'index', name: 'm-index', component: () => import('@/views/h5/pages/apply.vue') },
      { path: 'help/:collection_id?:doc_id?', name: 'm-help', component: () => import('@/views/party/help/index.vue') },
    ],
  },
]

export { pcRoutes, h5Routes }
